export class ReportsFilter {
    fromDate: string;
    toDate: string;
    grade: any;
    clazz: any;
    search: string;
    grades: string[];
    classes: string[];
    attendance:string[];
    dismissal:{};
    dismissalStatus;
    dismissalType;
    requestedBy;
}